
<template>
  <v-card class="video-preview">
    <v-toolbar
      class="pl-4"
      color="primary"
      style="box-shadow: none; background-color: #454d5d !important"
    >
      <v-toolbar-title class="text-h5 ml-2" style="color: #fff">{{
        rtmpOptions.title
      }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items style="height: 40px">
        <v-btn
          v-show="rtmpOptions.hasZoomLink"
          outlined
          color="white"
          class="mr-4 rounded-lg text-capitalize"
          style="background-color: #1a73e8"
          @click="rtmpActions(1, rtmpOptions.sessionId)"
        >
          <span class="numbering mr-1">1</span>
          Join on Zoom
        </v-btn>
        <v-btn
          v-show="rtmpOptions.rtmpStartLink && !rtmpOptions.ZoomRTMPStarted"
          :disabled="!rtmpOptions.ZoomMeetingStarted"
          outlined
          color="white"
          class="mr-4 rounded-lg text-capitalize"
          style="background-color: #1a73e8"
          :loading="rtmpOptions.startProcessing"
          @click="rtmpActions(2, rtmpOptions.sessionId)"
        >
          <span class="numbering mr-1">2</span>
          Start Live Broadcast
        </v-btn>
        <v-btn
          v-show="rtmpOptions.rtmpStopLink && rtmpOptions.ZoomRTMPStarted"
          outlined
          color="white"
          class="mr-4 rounded-lg text-capitalize"
          style="background-color: #bb0b0b"
          :loading="rtmpOptions.stopProcessing"
          @click="rtmpActions(3, rtmpOptions.sessionId)"
        >
          <span class="numbering mr-1">2</span>
          Stop Live Broadcast
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-container
      class="flex"
      style="
        height: 480px;
        margin: 0;
        padding: 0 15px 15px;
        background: #454d5d !important;
      "
    >
      <div
        class="d-flex"
        style="
          height: calc(100% - 80px);
          width: 100%;
          padding: 0 !important;
          position: relative;
          background: #000;
        "
      >
        <v-text
          class="ml-2 mt-2 px-2 rounded text-subtitle-1 preview-label"
          style="position: absolute"
          @click="debugPlayer"
        >
          PREVIEW
        </v-text>
        <v-text
          v-show="rtmpOptions.ZoomRTMPStarted && !isStreamReady && enableRetry"
          class="mt-10 pa-2 pl-10 rounded text-subtitle-1 retry-label"
          style="position: absolute"
        >
          <v-icon
            class="player-btn material-icons-round"
            @click="restartStreaming"
          >
            replay
          </v-icon>
          {{ retryText }}
        </v-text>
        <!--<v-icon
          v-show="rtmpOptions.ZoomRTMPStarted"
          class="player-btn material-icons-round"
          @click="playerAction"
        >
          {{ isStreamReady ? "pause" : "play_arrow" }}
        </v-icon>-->

        <video-player
          v-show="isStreamReady"
          ref="rtmpPlayer"
          id="rtmpPreview"
          class="vjs-custom-skin"
          :options="streamPlayerOptions"
          @ready="onStreamPlayerReady($event)"
          @play="onStreamPlayerPlay($event)"
          @pause="onStreamPlayerPause($event)"
          @loadeddata="onStreamPlayerLoadedData($event)"
          @canplay="onStreamPlayerCanPlay($event)"
          @canplaythrough="onStreamPlayerCanPlayThrough($event)"
          @waiting="onStreamPlayerWaiting($event)"
          @playing="onStreamPlayerPlaying($event)"
          @error="onStreamingError($event)"
        ></video-player>
        <div
          v-show="!isStreamReady"
          :data-after="previewNotReadyText"
          class="preview-not-ready"
        ></div>
      </div>
      <div
        class="d-flex"
        style="
          height: 80px;
          width: 100%;
          background: #566074;
          padding: 0px !important;
          border-radius: 0 0 10px 10px;
        "
      >
        <div class="pa-2" style="width: 50%">
          <div class="d-flex px-2" style="color: #fff">
            <div class="d-flex" style="width: 36px">
              <v-card-text class="pa-0 caption" style="width: 36px">
                Note:
              </v-card-text>
            </div>
            <div class="d-flex" style="width: calc(100% - 36px)">
              <v-card-text
                class="pa-0 caption float-left"
                style="width: calc(100% - 36px)"
              >
                There will be an approx 20 second delay between the actual zoom
                meeting and the live stream.
              </v-card-text>
            </div>
          </div>
          <div style="color: #fff" class="py-2 text-subtitle-2 float-none">
            <v-card-text class="ml-2 pa-0 text-subtitle-1">
              <v-icon color="white" class="mr-2">remove_red_eye</v-icon>
              {{ rtmpOptions.viewersCount }}
            </v-card-text>
          </div>
        </div>
        <div class="pa-0 mt-6 text-right" style="width: 50%">
          <v-btn
            :disabled="!rtmpOptions.ZoomRTMPStarted"
            outlined
            color="white"
            class="mr-4 pa-5 px-4 rounded-lg text-capitalize"
            style="background-color: #1a73e8"
            @click="rtmpActions(4, rtmpOptions.sessionId)"
          >
            <span
              v-if="rtmpOptions.rtmpStartLink"
              class="numbering mr-1"
              >3</span
            >
            <span v-else class="numbering mr-1">2</span>
            {{ attendeesInteractionBtnText }}
          </v-btn>
          <v-btn
            outlined
            color="white"
            class="mr-4 pa-5 px-4 rounded-lg text-capitalize"
            style="background-color: #393a3e"
            @click="rtmpActions(-1)"
          >
            Close
          </v-btn>
          <!--<v-btn
            outlined
            color="white"
            class="mr-4 pa-5 px-4 rounded-lg text-capitalize"
            style="background-color: #393a3e;"
            @click="startStreaming()"
          >
            Play
          </v-btn>-->
        </div>
      </div>
    </v-container>
  </v-card>
</template>

<script>
//import jQuery from "jquery";
//let $ = jQuery;
import db from "../components/firebaseInit";
import VideoPlayer from "@/components/VideoPlayer.vue";
let vm;
let users = ["42001", "221000", "221001", "99901500", "99900964"];
let retryPlayStreamTimer;
export default {
  name: "rtmp",
  components: {
    VideoPlayer,
  },
  props: {
    rtmpOptions: {
      type: Object,
      default: () => ({
        title: "Welcome",
        state: false,
        startProcessing: false,
        stopProcessing: false,
        sessionId: "",
        uid: "",
        event_collectionName: "",

        hasZoomLink: false,
        rtmpStartLink: false,
        rtmpStopLink: false,
        rtmpAudienceLink: false,
        viewersCount: 0,
        streamUrl: "",
        zoomUrl: "",
        ZoomMeetingStarted: false,
        ZoomRTMPStarted: false,
        chatEnabled: false,
        qnaEnabled: false,
        //attendeeEnabled: false,
      }),
    },
  },
  data() {
    return {
      rtmpComp: this,
      enableRetry: true,
      retryCounter: 0,
      retryInterval: 10,
      //retryText: "Retrying in 10 seconds",
      hasError: false,
      isPlaying: false,
      isStreamReady: false,
      PlayButtonText: "",
      previewNotReadyText: "Live Stream not started by the Host",
      attendeesInteractionBtnText: "Chat / QnA with Attendees",
      streamPlayerOptions: {
        autoplay: false,
        controls: false,
        //controlBar: {
        //  timeDivider: false,
        //  durationDisplay: false,
        //},
        // poster: 'https://surmon-china.github.io/vue-quill-editor/static/images/surmon-5.jpg'
      },
    };
  },
  created() {
    vm = this;
    //alert("created");
  },
  computed: {
    rtmpPlayer() {
      return vm.$refs.rtmpPlayer.player;
    },
    //AttendeesInteractionBtnText() {
    //  if (vm.rtmpOptions.chatEnabled) {
    //    alert("Chat with Attendees");
    //  }
    //  if (vm.rtmpOptions.qnaEnabled) {
    //    vm.attendeesInteractionBtnText = "QnA with Attendees";
    //    alert("QnA with Attendees");
    //  }
    //  return vm.attendeesInteractionBtnText;
    //},

    retryText() {
      return "Retrying in " + vm.retryCounter + " seconds";
    },
  },
  watch: {
    "rtmpOptions.sessionId"(val) {
      if (val == "") {
        //
      }
    },
    "rtmpOptions.ZoomMeetingStarted"() {
      vm.getPreviewNotReadyText();
    },
    "rtmpOptions.ZoomRTMPStarted"(val) {
      vm.getPreviewNotReadyText();
      if (val && !vm.isStreamReady) {
        setTimeout(() => {
          vm.startStreaming();
        }, 100);
      }
    },
    "rtmpOptions.chatEnabled"() {
      vm.getAttendeesInteractionBtnText();
    },
    "rtmpOptions.qnaEnabled"() {
      vm.getAttendeesInteractionBtnText();
    },
  },
  mounted() {
    if (retryPlayStreamTimer) {
      clearInterval(retryPlayStreamTimer);
    }
    vm.getPreviewNotReadyText();
  },
  beforeDestroy() {
    if (retryPlayStreamTimer) {
      clearInterval(retryPlayStreamTimer);
    }
  },
  methods: {
    getAttendeesInteractionBtnText() {
      if (!vm.rtmpOptions.chatEnabled && !vm.rtmpOptions.qnaEnabled) {
        vm.attendeesInteractionBtnText = "Chat / QnA with Attendees";
      } else if (vm.rtmpOptions.chatEnabled && vm.rtmpOptions.qnaEnabled) {
        vm.attendeesInteractionBtnText = "Chat / QnA with Attendees";
      } else {
        if (vm.rtmpOptions.chatEnabled) {
          vm.attendeesInteractionBtnText = "Chat / QnA with Attendees";
        } else if (vm.rtmpOptions.qnaEnabled) {
          vm.attendeesInteractionBtnText = "Chat / QnA with Attendees";
        }
      }
    },
    getPreviewNotReadyText() {
      if (!vm.rtmpOptions.ZoomMeetingStarted) {
        vm.previewNotReadyText = "Live Stream not started by the Host";
      } else {
        if (!vm.rtmpOptions.ZoomRTMPStarted) {
          vm.previewNotReadyText = "Live Streaming will begin soon...";
        } else {
          vm.previewNotReadyText = "Live Streaming will begin soon...";
        }
      }
    },
    rtmpActions(option, sessionId) {
      console.log(option);
      this.$emit("rtmpActions", option, sessionId);
    },
    stopStreaming: function () {
      vm.streamPlayer.reset();
    },
    startStreaming: function () {
      vm.hasError = false;
      //alert("playStream: " + vm.rtmpOptions.ZoomRTMPStarted);
      if (vm.rtmpOptions.ZoomRTMPStarted) {
        vm.isStreamReady = true;
        //alert("playStream");
        const video = {
          //autoplay: true,
          //controls: true,
          //techOrder: ["flash", "html5"],
          //sourceOrder: true,
          //Promise: vm.player.options_.Promise,
          withCredentials: false,
          type: "application/x-mpegurl",
          src: vm.rtmpOptions.streamUrl,
          //sources: [
          //  {
          //    type: "rtmp/mp4",
          //    src: "application/x-mpegurl",
          //  },
          //],
        };
        vm.rtmpPlayer.reset();
        vm.rtmpPlayer.src(video);
        //vm.rtmpPlayer.volume(0);
        vm.rtmpPlayer.muted(true);
        //setTimeout(() => {
        //  var vid = document.getElementById("vjs_video_3_html5_api");
        //  if (isNaN(vid)) {
        //    alert("Not ready");
        //  } else {
        //    alert("duration: " + vid.duration + "secs");
        //  }
        //}, 2000);
        // vm.player.load()
        //vm.player.trigger("usingnativecontrols");
        //vm.player.trigger("usingcustomcontrols");
        //vm.player.usingNativeControls_ = false;
        //vm.player.autoplay(true);

        //////vm.streamPlayer.muted(vm.muted);
        //////vm.streamPlayer.volume(vm.volumeLevel / 100);
        //vm.streamPlayer.currentTime(timeElapsed);
        //vm.streamPlayer.play();
        //console.log(timeElapsed);
        //setTimeout(() => {
        //$(":root").css("--click-here-to-proceed", "PLAY");
        //$(".vjs-big-play-button").attr("data-after", vm.PlayButtonText);
        //}, 2000);
      }
    },
    playerAction() {
      if (vm.isStreamReady) {
        vm.isStreamReady = false;
      } else {
        vm.isStreamReady = true;
        vm.startStreaming();
      }
    },
    restartStreaming() {
      if (vm.isStreamReady) {
        vm.isStreamReady = false;
      } else {
        if (retryPlayStreamTimer) {
          clearInterval(retryPlayStreamTimer);
        }
        vm.startStreaming();
      }
    },
    volumeChanged(volumeLevel) {
      //vm.player.currentTime(0);
      //vm.player.removeTechControlsListeners_();
      //alert(volumeLevel);
      vm.volumeLevel = volumeLevel;
      if (vm.selectedSessionTypeId == vm.GlobalKeysData.OnDemandTypeID) {
        vm.videoPlayer.volume(volumeLevel / 100);
      } else if (
        vm.selectedSessionTypeId == vm.GlobalKeysData.LiveStreamTypeID
      ) {
        vm.streamPlayer.volume(volumeLevel / 100);
      } else {
        vm.livePlayer.changePlayerVolume(volumeLevel);
      }
    },
    onStreamingError(player) {
      console.log(player);
      vm.videoPlayerLog(player.error_.message);
      //vm.showSnackbar(player.error_.message, "info", "top");
      vm.hasError = true;
      vm.isPlaying = false;
      vm.isStreamReady = false;
      if (vm.enableRetry) {
        vm.retryCounter = vm.retryInterval;
        if (retryPlayStreamTimer) {
          clearInterval(retryPlayStreamTimer);
        }
        retryPlayStreamTimer = setInterval(function () {
          if (vm.retryCounter > 0) {
            vm.retryCounter -= 1;
          }
          if (vm.retryCounter == 0) {
            vm.startStreaming();
            if (retryPlayStreamTimer) {
              clearInterval(retryPlayStreamTimer);
            }
          }
        }, 1000);
      }
    },
    onStreamPlayerReady(player) {
      console.log(player);
      //alert("onStreamPlayerReady");
      vm.videoPlayerLog("Ready");
    },
    onStreamPlayerPlay(player) {
      console.log(player);
      //alert("onStreamPlayerPlay");
      vm.videoPlayerLog("Play");
    },
    onStreamPlayerPause(player) {
      console.log(player);
      //alert("onStreamPlayerPause");
      vm.videoPlayerLog("Pause");
      vm.isStreamReady = false;
    },
    onStreamPlayerLoadedData(player) {
      console.log(player);
      //alert("onStreamPlayerLoadedData");
      vm.videoPlayerLog("LoadedData");
      //vm.startStreaming();
    },
    onStreamPlayerCanPlay(player) {
      console.log(player);
      //alert("onStreamPlayerCanPlay");
      vm.videoPlayerLog("CanPlay");
    },
    onStreamPlayerCanPlayThrough(player) {
      //vm.isStreamReady = true;
      console.log(player);
      //alert("onStreamPlayerCanPlayThrough");
      vm.videoPlayerLog("CanPlayThrough");
    },
    onStreamPlayerWaiting(player) {
      console.log(player);
      //alert("onStreamPlayerWaiting");
      vm.videoPlayerLog("Waiting");
    },
    onStreamPlayerPlaying(player) {
      console.log(player);
      //alert("onStreamPlayerPlaying");
      vm.videoPlayerLog("Playing");
    },
    debugPlayer() {
      if (users.includes(vm.rtmpOptions.uid)) {
        var vid = document.getElementById("vjs_video_3_html5_api");
        if (vid) {
          alert("duration: " + vid.duration + "secs");
        }
      }
    },
    videoPlayerLog(error) {
      //alert("videoPlayerLog");

      if (users.includes(vm.rtmpOptions.uid)) {
        let logId = new Date().getTime().toString();
        let logObj = new Object({
          sessionId: vm.rtmpOptions.sessionId,
          userId: vm.rtmpOptions.uid,
          error: error,
          CreatedDate: new Date(),
        });
        db.collection(vm.rtmpOptions.event_collectionName)
          .doc("UserVideoActivity")
          .collection("VideoPlayerLog")
          .doc(logId)
          .set(logObj)
          .then(function () {
            //alert("Success");
          })
          .catch(function (error) {
            console.log(error);
            //alert("Failure");
          });
      }
    },
  },
};
</script>

<style>
.video-preview .vjs-custom-skin.vjs-custom-skin {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100% !important;
  width: 100% !important;
}
.video-preview .vjs-custom-skin.vjs-custom-skin .video-js {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100% !important;
  width: 100% !important;
}
.video-preview .video-js .vjs-error-display.vjs-modal-dialog {
  display: none !important;
}
.video-preview .video-js.vjs-paused .vjs-loading-spinner {
  display: none;
}
.video-preview .video-js .vjs-control-bar {
  display: flex !important;
  background: transparent;
}
.video-preview .video-js .vjs-control-bar > .vjs-control {
  display: none;
}
.video-preview .video-js .vjs-control-bar .vjs-volume-panel {
  display: flex !important;
}
/*.vjs-custom-skin.vjs-custom-skin .video-js .vjs-control-bar * {
  display: none;
}*/
/*.vjs-custom-skin.vjs-custom-skin .video-js .vjs-control-bar {
  background: unset;
}*/
/*.vjs-custom-skin.vjs-custom-skin .video-js .vjs-big-play-button {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgb(26, 115, 232) !important;
  box-shadow: 0 5px #999;
  border: 1px solid #fff;
  font-size: 3em;
  line-height: 1.7em;
  height: 1.7em;
  width: 3em;
}*/
.video-preview .video-js .vjs-big-play-button {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #e03434 !important;
  box-shadow: 0 5px #999;
  border: 1px solid #fff;
  border-radius: 10px !important;
  font-size: 3em !important;
  line-height: 1.7em !important;
  height: 1.7em !important;
  width: 3em !important;
}
.video-preview .video-js.vjs-paused .vjs-big-play-button,
.video-preview .video-js.vjs-error .vjs-big-play-button {
  display: inline-block !important;
  opacity: 1 !important;
}
.video-preview .preview-not-ready {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100% !important;
  width: 100% !important;
  background: #292929 url("../assets/Player/images/cover-slide.png") center
    center no-repeat !important;
  background-size: cover !important;
}
.video-preview .preview-not-ready:before {
  /*content: "Live Streaming will begin soon...";*/
  content: attr(data-after);
  font-family: Roboto, sans-serif;
  font-size: 24px;
  font-weight: 500;
  color: #fff;
  height: 50px;
  padding-top: 50px;
  margin-bottom: 3px;
  background: url("../assets/Player/images/sand-clock.svg") center 50% no-repeat !important;
  background-size: 45px !important;
}
.video-preview .rounded-btn {
  border-radius: 0.1em;
}
.video-preview .preview-label {
  position: absolute;
  left: 10px;
  top: 10px;
  z-index: 9;
  background: #454d5d !important;
  color: #fff;
  user-select: none;
}
.video-preview .retry-label {
  position: absolute;
  left: 10px;
  top: 10px;
  z-index: 9;
  color: #fff;
  user-select: none;
}
.video-preview .player-btn {
  position: absolute !important;
  left: 10px !important;
  bottom: 10px !important;
  z-index: 9;
  color: #fff !important;
}
.v-dialog {
  border-radius: 10px !important;
}
.v-application .video-preview .caption {
  font-size: 12px !important;
  line-height: 16px !important;
}
.v-application .video-preview .text-subtitle-1 {
  font-size: 14px !important;
  line-height: 24px !important;
  overflow: hidden;
}
.v-application .video-preview .text-h5 {
  font-size: 24px !important;
}
.video-preview .theme--light.v-btn {
  border-radius: 5px !important;
  font-size: 14px !important;
}
.video-preview .theme--light.v-btn.v-btn--disabled {
  color: #fff !important;
  border-color: #fff !important;
  opacity: 0.4;
}
.video-preview .v-toolbar__content
{
    height:64px !important;
}
</style>